import React from "react";

const FujairahIndustries = ({ title, description, industries }) => {
  return (
    <section className="ft-industries-section">
      <div className="container">
        <div
          className="text-center mb-5"
          data-aos="fade-up"
          data-aos-once="true"
        >
          <h2>{title}</h2>
          {description && <p>{description}</p>}
        </div>

        <div className="row g-4">
          {industries.map((item, i) => (
            <div
              key={i}
              className="col-sm-6 col-lg-4"
              data-aos="fade-up"
              data-aos-delay={`${(i % 3) * 100}`}
              data-aos-duration="700"
              data-aos-once="true"
            >
              <div className="ft-industry-card">
                <i className={`bi ${item.icon} ft-industry-icon`}></i>
                <p className="ft-industry-title">{item.title}</p>
                <p>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FujairahIndustries;
